module.exports = __webpack_public_path__ + "img/square-key-tags.b8b160d9.jpg";